import { useMutation, useQueryClient } from "@tanstack/react-query";
import { RemindersKeys } from "web_myplann/Api/Reminders/RemindersKeys";
import {
	addReminderToListCache,
	refetchReminderListsOnConflict,
} from "web_myplann/Api/Reminders/remindersCacheUtils";
import {
	postPropertyPropertyIdRemindersV2,
	type ReminderResponseDTO,
} from "web_myplann/Infrastructure/Api/Api";
import { processResponse } from "web_myplann/Infrastructure/Api/ApiUtils";
import type { ReminderCreateFormModel } from "web_myplann/Reminders/Forms/reminderFormSchema";
import { mapReminderFormToCreateRequest } from "web_myplann/Reminders/Mappers/mapReminderToRequest";

type CreateReminderVariables = {
	propertyId: number;
	model: ReminderCreateFormModel;
};

export const usePropertyReminderCreateMutation = () => {
	const queryClient = useQueryClient();

	return useMutation<ReminderResponseDTO, Error, CreateReminderVariables>({
		mutationFn: processResponse(
			({ propertyId, model }: CreateReminderVariables) =>
				postPropertyPropertyIdRemindersV2(
					mapReminderFormToCreateRequest(model),
					propertyId,
				),
		),
		onError: (error, { propertyId }) => {
			refetchReminderListsOnConflict(
				queryClient,
				error,
				RemindersKeys.propertyList(propertyId),
			);
		},
		onSuccess: (reminder, { propertyId }) => {
			addReminderToListCache(
				queryClient,
				RemindersKeys.propertyList(propertyId),
				reminder,
			);
		},
	});
};
